import { createFileRoute } from '@tanstack/react-router'
import { ViagensDetalhesPage } from '@/pages/viagens/ViagensDetalhesPage'

export const Route = createFileRoute('/_auth/viagens/$id')({
  component: ViagensDetalhesPage,
})
